<template>
  <a-layout>
    <a-layout-header :style="{ position: 'fixed', zIndex: 10, width: '100%' }">
      <div class="logo" @click="() => (modalVisible = true)" style="cursor: pointer;">
        <img src="@/assets/logo-faces.png"/>
        <h1>TELAS</h1>
      </div>
      <a-menu
        theme="dark"
        mode="horizontal"
        :defaultSelectedKeys="[this.$route.path.split('/')[1]]"
        :selectedKeys="[this.$route.path.split('/')[1]]"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item key="/">
          <router-link to="/">Home</router-link>
        </a-menu-item>
        <a-menu-item key="dashboard">
          <router-link to="/dashboard">Dashboard</router-link>
        </a-menu-item>
        <a-menu-item key="login" v-if="! isUserLoggedIn">
          <router-link to="/login">Login</router-link>
        </a-menu-item>
        <a-menu-item key="4" v-if="isUserLoggedIn" @click="handleLogOut();">
          Logout
        </a-menu-item>
        <a-menu-item key="5" style="float:right;" v-if="! isUserLoggedIn">
          <a href="https://www.telas.edu.au/help-guidelines-table-of-contents" target="_blank"><a-icon type="question-circle"/>Help</a>
        </a-menu-item>
        <a-menu-item key="5" style="float:right;" v-else>
          <!-- <a href="https://telas.edu.au/help/ta" target="_blank" v-if="userRole === 'telas_telas_administrator'"><a-icon type="question-circle"/>Help</a> -->
          <a href="https://www.telas.edu.au/help-and-guidelines/course-submitters/" target="_blank" v-if="userRole === 'telas_course_submitters'"><a-icon type="question-circle"/>Help</a>
          <a href="https://www.telas.edu.au/help-and-guidelines/certified-reviewers/ " target="_blank" v-else-if="userRole === 'telas_certified_reviewers'"><a-icon type="question-circle"/>Help</a>
          <a href="https://www.telas.edu.au/help-and-guidelines/admin-reviewers/" target="_blank" v-else-if="userRole === 'telas_admin_reviewers'"><a-icon type="question-circle"/>Help</a>
          <a href="https://www.telas.edu.au/help-and-guidelines/interim-reviewers/" target="_blank" v-else-if="userRole === 'telas_interim_reviewers'"><a-icon type="question-circle"/>Help</a>
        </a-menu-item>
        <!-- <a-menu-item key="register" v-if="!isUserLoggedIn">
          <router-link to="/register" >Register</router-link>
        </a-menu-item> -->
      </a-menu>
    </a-layout-header>
    <a-modal
      v-model="modalVisible"
      title="TELAS APPLICATION"
      centered
      closable
      maskClosable
      :footer="null"
      width="60%"
    >
      <div class="modal-container">
        <div style="margin-bottom: 5px;">
          <a-icon type="global" /> https://www.app.telas.edu.au
          <a-icon type="deployment-unit" /> Version 1.0 (May 2020)
        </div>
        <div>
          <h3>Developed by ASCILITE</h3>
          www.ascilite.org
        </div>
        <a-card size="small" title="TELAS MANAGEMENT COMMITTEE" style="width: 100%; margin-top: 10px;">
          <a-card size="small" title="Professor Dominique Parrish" :bordered="false">
            Pro Vice-Chancellor (Learning and Teaching)
            Macquarie University
          </a-card>
          <a-card size="small" title="Mr Allan Christie" :bordered="false">
            Vice-President, eLearning, APAC (Retired)
            Blackboard Incorporated
          </a-card>
          <a-card size="small" title="Dr Chris Campbell" :bordered="false">
            Senior Lecturer Learning Innovation
            Griffith Universit
          </a-card>
        </a-card>
        <a-card size="small" title="TELAS SOFTWARE DEVELOPMENT" style="width: 100%; margin-top: 10px;">
          <a-card size="small" title="Andre Colbert" :bordered="false">
            Project Manager & TELAS Administrator
            <p>admin@telas.edu.au</p>
          </a-card>
          <a-card size="small" title="Bishal Basnet" :bordered="false">
            Senior Developer
            <p>bishal@toptal.com</p>
          </a-card>
        </a-card>
        <div style="margin-top: 10px;">
          <p>
            Special thanks to all those who participated in TELAS workshops and reference groups from 2017 - 2019 along with Oleg Estrin (Griffith University) for his assistance with early software tests.
          </p>
        </div>
      </div>
    </a-modal>
  </a-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'main-header',
  data() {
    return {
      modalVisible: false,
    };
  },
  mounted() {
  },
  computed: {
    ...mapGetters('user', {
      isUserLoggedIn: 'isUserLoggedIn',
      isUserCourseSubmitter: 'isUserCourseSubmitter',
      userToken: 'getUserToken',
      userRole: 'getUserRole',
    }),
  },
  methods: {
    ...mapActions('user', {
      logoutUser: 'logoutUser',
    }),
    handleLogOut() {
      this.logoutUser({ userToken: this.userToken });
    },
  },
};
</script>
<style scoped>
  .logo {
    height: 30px;
    margin: 0px 75px 0px 0;
    float: left;
  }
  .logo h1 {
    color: white;
    margin-left: 5px;
    clear: none;
    display: inline;
    font-weight: normal;
  }
  .logo img {
    max-width: 40px;
    margin-bottom: 10px;
  }
</style>
